import React, { useState, useEffect } from "react";

const DiaryVerificationSlider = () => {
  const [lstSubject, setLstSubject] = useState([
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
    {
      rollno: "1",
      name: "Aman",
      gender: "M",
      status: "Pending/Completed/Verified",
      completedon: "22-Jun 3:30 pm",
      verifiedon: "24-Jun 9:30 am ",
      verify: "",
    },
  ]);
  const colgrp = (
    <colgroup>
      <col width="10%"></col>
      <col width="10%"></col>
      <col width="10%"></col>
      <col width="20%"></col>
      <col width="10%"></col>
      <col width="10%"></col>
      <col width="10%"></col>
    </colgroup>
  );

  return (
    <div>
      <div className="row">
        <label className="col-sm-2 Label">class</label>
        <div className="form-group col-sm-2">
          <input type="text" className="form-control"></input>
        </div>
      </div>
      <div className="row">
        <label className="col-sm-2 Label">Subject</label>
        <div className="form-group col-sm-2">
          <input type="text" className="form-control"></input>
        </div>
      </div>

      <div className="row">
        <label className="col-sm-2 Label">Topic</label>
        <div className="form-group col-sm-2">
          <input type="text" className="form-control"></input>
        </div>
      </div>

      <div className="row">
        <label className="col-sm-2 Label">Diary</label>
        <div className="form-group col-sm-8">
          <input type="text" className="form-control"></input>
        </div>
      </div>

      <div className="col-sm-10 col-centered">
        <table className="tableLayout1">
          {colgrp}

          <thead>
            <tr>
              <th>Roll No</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Status</th>
              <th>Completed On</th>
              <th>Verified On</th>
              <th>verify</th>
            </tr>
          </thead>
        </table>
        <div className="tablebodyWrapper">
          <table className="tableLayout">
            {colgrp}
            <tbody>
              {lstSubject.map((value, key) => {
                return (
                  <tr key={key}>
                    <td className="text-centered">{value.rollno}</td>
                    <td className="text-centered">{value.name}</td>
                    <td className="text-centered">{value.gender}</td>
                    <td className="text-centered">{value.status}</td>
                    <td className="text-centered">{value.completedon}</td>
                    <td className="text-centered">{value.verifiedon}</td>
                    <td className="text-centered">{value.verify}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="form-group col-sm-6">
                <button type="button" className="btnVerifyAll">Verify All</button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default DiaryVerificationSlider;
